import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import "./index.scss";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={<p>⚠️Something went wrong. Please refresh the page</p>}
    >
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
